import React, { useContext, useEffect, useState } from 'react'
import Skeleton from 'react-loading-skeleton'
import { useNavigate } from 'react-router-dom'
// Api
import { getCard, requestNewCard } from 'api/credit-card'
// Context
import { MeContext } from 'contexts/me'
// Utils
import { trackEvent } from 'analytics/trackFunctions'

// Components
import PrimaryButton from 'components/primaryButton'
import PageWrapper from 'components/PageWrapper'
import PhysicalCardRequestErrorModal from 'components/PhysicalCardRequestErrorModal'

const WayniCardAddress = () => {
  // request error modal
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [loading, setLoading] = useState(false)
  const [disabled] = useState(false)
  const [legalAddress, setLegalAddress] = useState()
  const [, setCard] = useState(null)

  const address = localStorage.getItem('address') || null

  const { me } = useContext(MeContext)
  const navigate = useNavigate()

  useEffect(() => {
    preventGoBack()
  }, [])

  useEffect(() => {
    setLoading(true)
    if (me) {
      setLegalAddress(me?.profile?.legal_address)
      setLoading(false)
      trackEvent({ eventName: 'bille_pantalla_pedir_tarjeta_fisica_direccion' })
    }
  }, [me])

  const preventGoBack = () => {
    setLoading(true)
    getCard({ data: me?.user?.uuid, type: 'PHYSICAL' })
      .then((res) => {
        setCard(res.data)
        if (res.data?.card_status === 'PENDING' || address)
          navigate('/mis-tarjetas', { replace: true })
      })
      .catch((error) => Sentry.captureException(error))
      .finally(() => setLoading(false))
  }

  const handleLegalAddress = () => {
    setLoading(true)
    requestNewCard({
      card_type: 'PHYSICAL',
      address: {
        ...legalAddress,
        floor: legalAddress?.floor ? legalAddress.floor : null,
        apartment: legalAddress?.apartment ? legalAddress.apartment : null
      }
    })
      .then((res) => {
        if (res.success) {
          sessionStorage.setItem('address', JSON.stringify(res.data?.address))
          trackEvent({
            eventName: 'bille_boton_pedir_tarjeta_fisica_confirmar_direccion',
            props: {
              provincia: legalAddress?.region,
              ciudad: legalAddress?.city,
              calle: legalAddress?.street_name,
              altura: legalAddress?.street_number,
              piso: legalAddress?.floor,
              cp: legalAddress?.zip_code,
              depto: legalAddress?.apartment
            }
          })
          navigate('/seguimiento-tarjeta-fisica', { replace: true })
        } else {
          trackEvent({
            eventName: 'bille_boton_tarjeta_fisica_solicitar_error',
            props: {
              error: JSON.stringify(res)
            }
          })
          setIsModalOpen(true)
        }
      })
      .catch((error) => {
        trackEvent({
          eventName: 'bille_boton_tarjeta_fisica_solicitar_error_catch',
          props: {
            error: JSON.stringify(error)
          }
        })
        setIsModalOpen(true)
      })
  }

  return (
    <PageWrapper title='Tarjeta Wayni'>
      <section
        className='flex flex-col justify-between md:max-w-564 mx-auto '
        style={{ height: '80vh' }}
      >
        <div className='flex items-center flex-col'>
          <h3 className='text-black text-3xl mt-9 font-bold text-center'>
            ¡Tener Tarjeta Wayni es muy fácil!
          </h3>
          <span className='text-xs text-center text-black mt-4 font-medium flex flex-col'>
            Confirmanos tu dirección para enviar la tarjeta a tu domicilio
          </span>
          <h1 className='font-bold text-2xl text-center text-black mt-6'>
            ¿Esta es tu dirección actual?
          </h1>
          {loading ? (
            <div className='mt-5 w-full rounded-lg'>
              <Skeleton height={85} className='mt-5' />
            </div>
          ) : (
            <div className='flex w-full items-start py-2 justify-start mt-10 border-2 rounded-lg bg-white '>
              <div className='pl-3 '>
                <strong className='capitalize text-black text-xs'>
                  {legalAddress?.street_name} {'  '}
                  {legalAddress?.street_number}
                </strong>
                {legalAddress?.floor && legalAddress?.apartment && (
                  <p className='font-sans text-black text-xs'>
                    Piso {legalAddress?.floor}, Depto
                    <span className='uppercase'>
                      {' '}
                      {legalAddress?.apartment}
                    </span>
                  </p>
                )}

                <p className='font-medium font-sans text-black text-xs'>
                  {legalAddress?.zip_code}, {legalAddress?.city}
                </p>
              </div>
            </div>
          )}
        </div>

        <div className='sm:w-full sm:mx-auto'>
          <PrimaryButton
            buttonText='Si, es mi dirección'
            className='mt-4'
            type='submit'
            primaryButtonFunction={() => {
              handleLegalAddress()
            }}
          />

          <PrimaryButton
            buttonText='No, no es mi dirección'
            className='my-4'
            outlined
            type='button'
            margins=''
            primaryButtonFunction={() => {
              navigate('/actualizar-direccion-tarjeta-fisica')
            }}
            isDisabled={disabled || loading}
          />
        </div>
        <PhysicalCardRequestErrorModal
          isOpen={isModalOpen}
          setIsOpen={setIsModalOpen}
        />
      </section>
    </PageWrapper>
  )
}

export default WayniCardAddress
